import { Component } from '@angular/core';

@Component({
  selector: 'app-prescrizioni',
  templateUrl: './prescrizioni.component.html',
  styleUrls: ['./prescrizioni.component.css']
})
export class PrescrizioniComponent {

}
